export enum CreativeTagTracking {
  INIT = 'Init',
  REQUEST = 'Request',
  LOAD = 'Load',
  INSTALLED = 'Installed',
  DISPLAY = 'Display',
  VIEW = 'View',
  TIMESPENT = 'timespent',
  SHOW = 'Show',
  CLICK = 'Click',
  FAIL = 'Fail'
}
